import { keepTogether, MISSING_NUMBER, numberLocale } from './locale';

export interface PercentFormatOptions {
  /** Show the sign for positive values too, e.g. price changes "+2,50 %". */
  signed?: boolean;
  /** Fixed number of decimals; default: up to 2, trailing zeros dropped ("20 %", "7,5 %"). */
  fractionDigits?: number;
}

const formatters = new Map<string, Intl.NumberFormat>();

/**
 * Formats percentage points in the UI language: 20 → "20 %" (de, sl), "20%" (en).
 * A missing value renders as "—".
 */
export function formatPercent(points?: number | null, options: PercentFormatOptions = {}): string {
  if (points == null) return MISSING_NUMBER;
  const { signed = false, fractionDigits } = options;
  const locale = numberLocale();
  const key = `${locale}|${signed}|${fractionDigits}`;
  let cached = formatters.get(key);
  if (!cached) {
    cached = new Intl.NumberFormat(locale, {
      style: 'percent',
      signDisplay: signed ? 'exceptZero' : 'auto',
      minimumFractionDigits: fractionDigits ?? 0,
      maximumFractionDigits: fractionDigits ?? 2,
    });
    formatters.set(key, cached);
  }
  return keepTogether(cached.format(points / 100));
}
